import React from 'react'
import OmowienieZasad from './OmowienieZasad'
import MetodyWyceny from './MetodyWyceny'
import UstalenieWynikuFinansowego from './UstalenieWynikuFinansowego'
import UstalenieSposobuSporzadzenia from './UstalenieSposobuSporzadzenia'
import ZasadyGrupowania from './ZasadyGrupowania'
import MetodyAmortyzacji from './MetodyAmortyzacji'
import PolitykaRachunkowosciPozostale from './PolitykaRachunkowosciPozostale'

export default function PolitykaRachunkowosciSkonsolidowanaV12(props) {
  return (
    <>
      <OmowienieZasad
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <ZasadyGrupowania
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <MetodyWyceny
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <MetodyAmortyzacji
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <UstalenieWynikuFinansowego
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <UstalenieSposobuSporzadzenia
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <PolitykaRachunkowosciPozostale
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
    </>
  )
}
